import { render } from "./FormComplaintObservations.vue?vue&type=template&id=9e436dba"
import script from "./FormComplaintObservations.vue?vue&type=script&lang=js"
export * from "./FormComplaintObservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__